import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import {
  getCachedProfile,
  loadProfileWithCache,
  setCachedProfile,
} from './profileCache';

export const loadUserProfile = (uid) =>
  loadProfileWithCache(uid, async () => {
    const startedAt = performance.now();

    if (process.env.NODE_ENV === 'development') {
      console.debug('[PROFILE USER FIRESTORE START]', { uid, time: startedAt });
    }

    const snapshot = await getDoc(doc(db, 'users', uid));

    if (process.env.NODE_ENV === 'development') {
      console.debug('[PROFILE USER FIRESTORE COMPLETE]', {
        uid,
        duration: performance.now() - startedAt,
      });
    }

    if (!snapshot.exists()) {
      return null;
    }

    return {
      id: snapshot.id,
      ...snapshot.data(),
    };
  });

export {
  getCachedProfile as getCachedUserProfile,
  setCachedProfile as setCachedUserProfile,
};
